import TextLink, { TextLinkProps } from "./TextLink";

export { TextLink, TextLinkProps };

export default TextLink;
